import React from "react";
import { Star, Quote, CheckCircle2 } from "lucide-react";
import { FaGoogle } from "react-icons/fa";
import { RATING, REVIEWS_COUNT, REVIEWS_LIST } from "@/lib/site";
import { Reveal, Overline } from "@/components/site/Reveal";
import { WhatsappButton } from "@/components/site/WhatsappButton";

export const Reviews = () => {
  return (
    <section
      id="avaliacoes"
      data-testid="reviews-section"
      className="relative py-24 md:py-36 bg-[#6E3C36] text-clinic-bg overflow-hidden"
    >
      {/* Soft Gold & Rose Glows */}
      <div className="pointer-events-none absolute -top-28 left-1/2 -translate-x-1/2 h-80 w-80 rounded-full bg-clinic-pink/20 blur-3xl gpu-accel" />
      <div className="pointer-events-none absolute bottom-0 right-10 h-72 w-72 rounded-full bg-clinic-gold/15 blur-3xl gpu-accel" />

      <div className="relative mx-auto max-w-7xl px-6 flex flex-col items-center">
        {/* Section Header */}
        <Reveal>
          <div className="flex items-center gap-3 mb-6 justify-center">
            <span className="h-px w-8 bg-clinic-pink/60" />
            <span className="font-sans text-xs uppercase tracking-[0.35em] text-clinic-pink font-semibold">
              03 · Avaliações
            </span>
            <span className="h-px w-8 bg-clinic-pink/60" />
          </div>
        </Reveal>

        {/* Rating and Google verification */}
        <div className="text-center max-w-2xl mb-14">
          <Reveal delay={0.1}>
            <div className="flex items-center justify-center gap-1.5 mb-5">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-7 w-7 fill-clinic-gold text-clinic-gold" />
              ))}
            </div>
          </Reveal>

          <Reveal delay={0.15}>
            <p className="font-serif text-7xl md:text-8xl leading-none font-medium text-white">{RATING}</p>
          </Reveal>

          <Reveal delay={0.2}>
            <h2 className="mt-4 font-serif italic text-3xl md:text-5xl leading-tight text-clinic-bg">
              Aprovada por quem já é cliente
            </h2>
          </Reveal>

          <Reveal delay={0.25}>
            <p className="mt-4 inline-flex items-center gap-2 font-sans text-sm text-clinic-bg/85 bg-white/10 backdrop-blur-md px-4 py-1.5 rounded-full border border-white/15">
              <FaGoogle className="h-4 w-4 text-clinic-pink" />
              <span>Nota máxima em {REVIEWS_COUNT} avaliações verificadas no Google</span>
            </p>
          </Reveal>
        </div>

        {/* Testimonial Cards Grid */}
        <div className="w-full grid grid-cols-1 md:grid-cols-3 gap-6 mb-14">
          {REVIEWS_LIST.map((rev, i) => (
            <Reveal key={rev.name} delay={0.15 + i * 0.1}>
              <div className="relative h-full flex flex-col justify-between bg-white/10 backdrop-blur-md rounded-3xl border border-white/15 p-7 transition-all duration-300 hover:bg-white/15 hover:border-white/25 hover:-translate-y-1 shadow-soft">
                <div>
                  <div className="flex items-center justify-between mb-4">
                    <div className="flex items-center gap-1">
                      {[...Array(rev.rating)].map((_, idx) => (
                        <Star key={idx} className="h-4 w-4 fill-clinic-gold text-clinic-gold" />
                      ))}
                    </div>
                    <Quote className="h-6 w-6 text-clinic-pink/50" />
                  </div>
                  <p className="font-sans text-sm text-clinic-bg/90 leading-relaxed italic">
                    "{rev.comment}"
                  </p>
                </div>

                <div className="mt-6 pt-4 border-t border-white/10 flex items-center justify-between">
                  <div>
                    <p className="font-serif text-lg font-medium text-white leading-none">
                      {rev.name}
                    </p>
                    <p className="font-sans text-xs text-clinic-pink/80 mt-1 flex items-center gap-1">
                      <CheckCircle2 className="h-3 w-3 text-clinic-pink" />
                      {rev.role}
                    </p>
                  </div>
                  <span className="font-sans text-[0.65rem] text-clinic-bg/60 uppercase tracking-wider">
                    {rev.date}
                  </span>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        {/* Action Button */}
        <Reveal delay={0.45}>
          <div>
            <WhatsappButton
              label="Agendar Consulta pelo WhatsApp"
              variant="gold"
              testId="reviews-whatsapp-cta"
            />
          </div>
        </Reveal>
      </div>
    </section>
  );
};

